import type { iCustomerCreditVoucher } from "@sdk/customer-credit-vouchers/customer-credit-voucher-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { customerCreditVouchersDefaultQueryConfig } from "./customer-credit-vouchers-default-query";

export const {
  slice: CustomerCreditVouchersSlice,
  reducers: CustomerCreditVouchersSliceReducer,
  actions: {
    setEntityQueryResults: setCustomerCreditVouchersQueryResults,
    setEntity: setCustomerCreditVoucher,
    setEntities: setCustomerCreditVouchers,
    patchEntity: patchCustomerCreditVoucher,
    addNewEntity: addNewCustomerCreditVoucher,
    setEntityFetchingStatus: setCustomerCreditVoucherFetchingStatus,
    setEntitiesFetchingStatus: setCustomerCreditVouchersFetchingStatus,
    setEntityFailedStatus: setCustomerCreditVoucherFailedStatus,
    setEntityQueryError: setCustomerCreditVouchersQueryError,
    resetQuery: resetCustomerCreditVouchersQuery,
    setQueryList: setCustomerCreditVoucherQueryList,
  },
} = CreateEntitySlice<iCustomerCreditVoucher>({
  sliceName: "customerCreditVouchers",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...customerCreditVouchersDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
